import { instBundle } from '@/axios.js';
import _ from 'lodash';
import util from '@/util.js';

const axiosAdmin2 = instBundle.axiosAdmin2;

export default {
	namespaced: true,
	state: {
		productCheckList: [],
		storeList: [],
		lastParams: {},
		totalItem: 0,
	},
	getters: {
		selectboxStoreList(state) {
			const list = _.cloneDeep(state.storeList);
			list.unshift({
				id: null,
				name: '스토어 선택(단일 조건 검색)',
			});
			return list;
		},
	},
	mutations: {
		changeState(state, list) {
			list.forEach(item => {
				state[item.key] = item.value;
			});
		},
	},
	actions: {
		async downExcel({ state, rootState }, { limit, offset }) {
			try {
				const params = {};
				const arrParams = [];
				for (let key in state.lastParams) {
					params[key] = state.lastParams[key];
				}
				params.limit = limit;
				params.offset = offset;
				for (let key in params) {
					arrParams.push(`${key}=${params[key]}`);
				}
				const url = `/api/products/list/exportExcel?${arrParams.join('&')}`;
				const res = await axiosAdmin2.get(url, {
					responseType: 'blob',
				});
				util.exportExcel(res);
			} catch (err) {
				console.error(err);
				alert('엑셀 다운로드에 실패했습니다. 개발팀에 문의하세요.');
			}
		},
		async getStoreList({ state }) {
			try {
				const { data } = await axiosAdmin2.get('/api/products/store');
				state.storeList = data.data.map(item => {
					return {
						id: item.idBrandType,
						name: `${item.isDisplay === 'N' ? '[비전시]' : ''}${item.brandTypeName}`,
					};
				});
			} catch (err) {
				alert(
					'스토어 리스트 불러오기에 실패했습니다. 개발팀에 문의하세요.'
				);
			}
		},
		async changeStoreBatch({ state, commit }, storeIdList) {
			try {
				const params = {
					storeIdList,
					idProducts: state.productCheckList,
				};
				await axiosAdmin2.put('/api/products/stores', params);
				commit('modal/toggleModal', false, { root: true });
				window.location.reload();
			} catch (err) {
				console.error(err);
				alert(
					'판매처 일괄변경 작업에 실패했습니다. 개발팀에 문의하세요.'
				);
			}
		},
		async changeBrandBatch({ state, commit }, idBrand) {
			try {
				const params = {
					idBrand,
					idProducts: state.productCheckList,
				};
				await axiosAdmin2.put('/api/products/brand-change', params);
				commit('modal/toggleModal', false, { root: true });
				window.location.reload();
			} catch (err) {
				alert(
					'브랜드 일괄변경 작업에 실패했습니다. 개발팀에 문의하세요.'
				);
			}
		},
		async changeDisplay({ state }, isDisplay) {
			try {
				const params = {
					isDisplay,
					idProducts: state.productCheckList,
				};
				await axiosAdmin2.put(
					'/api/products/toggleAllProductsDisplayStatus',
					params
				);
				alert('일괄 변경되었습니다.');
				window.location.reload();
			} catch (err) {
				alert('일괄 변경에 실패하였습니다. 개발팀에 문의하세요.');
			}
		},
	},
};
